module.exports = __webpack_public_path__ + "img/mastercard.f03eb0e3.png";